export default "__VITE_ASSET__ee53cb6c__"